var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-whatever"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12","sm":"6"}},[_c('div',{staticClass:"content-catering-image",style:({
          backgroundImage: _vm.backgroundImage 
          })})]),_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12","sm":"6"}},[_c('form-layout')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }